import { render } from "./VideoModal.vue?vue&type=template&id=8673bdac&scoped=true"
import script from "./VideoModal.vue?vue&type=script&lang=js"
export * from "./VideoModal.vue?vue&type=script&lang=js"

import "./VideoModal.vue?vue&type=style&index=0&id=8673bdac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8673bdac"

export default script